import React, { useRef, useState } from 'react'
import { Dimensions, Platform, TouchableOpacity } from 'react-native'
import PropTypes from 'prop-types'

import { QuickActionMenu, VFText, VFButton } from '@vfgroup-oneplatform/foundation/Components'

import { withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'

import VerifyCode from '../VerifyCode'

import styles from './VerifyCodeModal.Styles'
import Modal from 'react-native-modal'
import { View } from 'native-base'

const VerifyCodeModal = ({
  msisdn,
  isVisible,
  toggleModal,
  resendCodeLoading,
  resendCode,
  codeConfirm,
  formattedCount,
  theme,
}) => {

  const verifyCodeInput = useRef()
  const [pin, setPin] = useState(null)

  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <Modal
        isVisible={isVisible}
        backdropOpacity={0.5}
        onSwipeComplete={toggleModal}
        onBackdropPress={toggleModal}
        propagateSwipe
        hideModalContentWhileAnimating
        hardwareAccelerated
        backdropTransitionOutTiming={0}
        style={{
          justifyContent: 'flex-end',
          margin: '0 !important',
          minWidth: 1920,
          maxWidth: 1920,
        }}
      >
        <View
          style={{
            minWidth: '600px',
            maxWidth: '600px',
            height: 'auto',
            backgroundColor: theme.colors.background.primary[0],
            margin: 'auto',
            padding: '20px',
            paddingTop: null,
            borderRadius: "7px",
          }}
          onStartShouldSetResponder={() => true}>
          <VFText
            i18nKey="acquisition_verify_code_title"
            style={styles.verifyTitle}
          />
          <VFText
            i18nKey="acquisition_verify_code_subtitle"
            style={styles.verifyDesc}
          />
          <VFText
            i18nKey={msisdn}
            style={styles.numberText}
          />
          <VFText
            i18nKey="acquisition_verify_code_desc"
            style={styles.verifyDesc}
          />
          <VerifyCode
            coderRef={verifyCodeInput}
            codeLength={5}
            keyboardType="default"
            handlerOnFulfill={(pinText) => setPin(pinText)}
            theme={theme}
          />
          <TouchableOpacity onPress={resendCode}>
            {
              resendCodeLoading ? <VFText
                i18nKey="acquisition_verify_code_resend_code_disabled"
                placeHolders={[formattedCount]}
                style={styles.resendTextDisabled}
              /> : <VFText
                i18nKey="acquisition_verify_code_resend_code"
                style={styles.resendText}
              />
            }
          </TouchableOpacity>
          <VFButton
            title="acquisition_verify_code_confirm"
            onPress={() => codeConfirm(pin)}
            disabled={!pin}
          />
          <VFButton
            title="acquisition_verify_code_cancel"
            type="secondary"
            style={styles.button}
            onPress={toggleModal}
          />
        </View>
      </Modal>
    )
  }



  return (
    <QuickActionMenu
      isVisible={isVisible}
      toggleModal={toggleModal}
      title="acquisition_screen_title"
      type="secondary"
    >
      <VFText
        i18nKey="acquisition_verify_code_title"
        style={styles.verifyTitle}
      />
      <VFText
        i18nKey="acquisition_verify_code_subtitle"
        style={styles.verifyDesc}
      />
      <VFText
        i18nKey={msisdn}
        style={styles.numberText}
      />
      <VFText
        i18nKey="acquisition_verify_code_desc"
        style={styles.verifyDesc}
      />
      <VerifyCode
        coderRef={verifyCodeInput}
        codeLength={5}
        keyboardType="default"
        handlerOnFulfill={(pinText) => setPin(pinText)}
        theme={theme}
      />
      <TouchableOpacity onPress={resendCode}>
        {
          resendCodeLoading ? <VFText
            i18nKey="acquisition_verify_code_resend_code_disabled"
            placeHolders={[formattedCount]}
            style={styles.resendTextDisabled}
          /> : <VFText
            i18nKey="acquisition_verify_code_resend_code"
            style={styles.resendText}
          />
        }
      </TouchableOpacity>
      <VFButton
        title="acquisition_verify_code_confirm"
        onPress={() => codeConfirm(pin)}
        disabled={!pin}
      />
      <VFButton
        title="acquisition_verify_code_cancel"
        type="secondary"
        style={styles.button}
        onPress={toggleModal}
      />
    </QuickActionMenu>
  )
}

VerifyCodeModal.propTypes = {
  msisdn: PropTypes.string,
  isVisible: PropTypes.bool,
  toggleModal: PropTypes.func,
  resendCodeLoading: PropTypes.func,
  resendCode: PropTypes.bool,
  codeConfirm: PropTypes.func,
  formattedCount: PropTypes.string,
}

export default withTheme(VerifyCodeModal)
